import { autorun, makeAutoObservable } from "mobx";
import { StoreNameEnum } from "../../enum/storesEnum";
import { AttributeShelf } from "../../shelves";
import type { PaymentInfoStateStore } from "./interface";
import CryptoJS from "crypto-js";
import { env } from "../../config";

export enum PaymentInfoEnum {
	PIX = "PIX",
	TED = "TED",
}

export class PaymentInfo {
	public transferType = new AttributeShelf<PaymentInfoEnum | null>(null);
	public pixKey = new AttributeShelf("");
	public pixKeyType = new AttributeShelf("");

	constructor() {
		makeAutoObservable(this);

		// Carrega o estado salvo do localStorage
		this.loadState();

		// Monitora mudanças e salva o estado automaticamente
		autorun(() => {
			this.saveState();
		});
	}

	// Limpa o estado
	public clearState(): void {
		sessionStorage.removeItem(StoreNameEnum.PAYMENT_INFO);
	}

	// Reinicializa o estado da PaymentInfo
	public resetState(): void {
		this.resetStatePaymentInfo();
	}

	private resetStatePaymentInfo(): void {
		this.transferType.set(null);
		this.pixKey.set("");
		this.pixKeyType.set("");
	}

	// Salva o estado atual no sessionStorage
	private saveState(): void {
		const state = {
			transferType: this.transferType.value,
			pixKey: this.pixKey.value,
			pixKeyType: this.pixKeyType.value,
		};

		const cipherInfo: string = CryptoJS.AES.encrypt(JSON.stringify(state), env.cryptoKey).toString();
		sessionStorage.setItem(StoreNameEnum.PAYMENT_INFO, cipherInfo);
	}

	// Carrega o estado salvo do sessionStorage
	private loadState(): void {
		const savedState = sessionStorage.getItem(StoreNameEnum.PAYMENT_INFO);
		if (savedState) {
			const bytes = CryptoJS.AES.decrypt(savedState, env.cryptoKey);
			const decryptedData: string = bytes.toString(CryptoJS.enc.Utf8);
			const state: PaymentInfoStateStore = JSON.parse(decryptedData);
			this.transferType.set(state.transferType);
			this.pixKey.set(state.pixKey);
			this.pixKeyType.set(state.pixKeyType);
		}
	}
}
